<template>
    <label
        ref="field"
        :class="[
            hasBorderTopBottom,
            size,
            {'ui-input-group': group || groupicon},
            {'invert-order': invertgroup},
            containerDesign,
            {'error': setError}
        ]"
        class="ui-input"
        :style="{'width': width}">
        <span v-if="label" class="label">
            <div>
                <span :style="{'color' :labelColor}">{{ label }}</span>
                <span v-if="required" class="label-required">*</span>
            </div>
            <div>
                <span v-if="rightLabel != '' && tooltip.message" class="rigth-label tooltip">
                    <div :style="{'cursor': tooltip.cursor ?  tooltip.cursor : 'default'}" @mouseover="openTootip = true" @mouseout="openTootip = false">
                        <strong> {{rightLabel}} </strong>
                        <div v-if="openTootip" :style="{'width': tooltip.width ? tooltip.width : 'auto', 'cursor': tooltip.cursor ?  tooltip.cursor : 'default'}" class="info">{{ tooltip.message }}</div>
                    </div>
                    <!-- {{ rightLabel }} -->
                </span>
                <span v-else-if="rightLabel != ''" class="rigth-label">
                    {{ rightLabel }}
                </span>
            </div>
        </span>

        <input
            v-if="mask"
            :ref="refer"
            v-mask="mask"
            :type="type"
            :name="name"
            :value="value"
            :class="design"
            :disabled="disabled"
            :placeholder="placeholder"
            :readonly="readonly"
            :required="required"
            :maxlength="maxlength"
            :style="{'background-color': backgroundColor}"
            :data-ui="dataUi || null"
            class="input"
            autocomplete="off"
            @input="change"
            @focus="onFocus"
            @blur="onBlur"
            @reset="onReset"
            @submit="onSubmit"
            @select="onSelect"
            @keyup="verifyCompleteEvent"
        />
		
        <input
            v-else-if="maskIntl"
            ref="referMaskIntl" 
            :key="maskDinamic"
            v-mask="maskDinamic"
            :type="type"
            :name="name"
            :value="localValueIntlNumber"
            :placeholder="placeholder"
            :class="design"
            :disabled="disabled"
            :readonly="readonly"
            :required="required"
            :maxlength="maxlength"
            :style="{'background-color': backgroundColor}"
            :data-ui="dataUi || null"
            class="input"
            autocomplete="off"
            @input="change"
            @focus="onFocus"
            @blur="onBlur"
            @reset="onReset"
            @submit="onSubmit"
            @select="onSelect"
            @paste="onPaste"
            @keyup="verifyCompleteEvent"
        />

        <label v-else-if="type == 'time'" ref="timeLabel" class="time-container" :class="design">
            <div class="time-buttons">
                <div class="time-hour">
                    <input v-model="hour" v-mask="'##'" type="text" class="input-hour" @input="maxTime('hour')"/>
                    :
                    <input v-model="min" v-mask="'##'" type="text" class="input-min" @input="maxTime('min')"/>
                </div>
                <div class="time-select-hour">
                    <button class="time-button" @click="timeActved = !timeActved"> <em :class="groupicon" :style="{'color': groupIconColor}"/> </button>
                </div>
            </div>
            <div class="time-selects">
                <div v-show="timeActved" class="select-hour-mins">
                    <div class="select-times">
                        <div v-for="(time, index) in times.hours" :key="index" :class="{'active': time == hour}" class="select-times-button" @click="setHour(time)" @keydown.enter="setHour(time)">
                            {{time}}
                        </div>
                    </div>
                    <div class="select-times">
                        <div v-for="(time, index) in times.min" :key="index" :class="{'active': time == min}" class="select-times-button" @click="setMin(time)" @keydown.enter="setMin(time)">
                            {{time}}
                        </div>
                    </div>
                </div>
            </div>
        </label>

        <input
            v-else
            :ref="refer"
            :type="type"
            :name="name"
            :value="valueComputed"
            :placeholder="placeholder"
            :class="design"
            :disabled="disabled"
            :readonly="readonly"
            :required="required"
            :maxlength="maxlength"
            :style="{'background-color': backgroundColor}"
            :data-ui="dataUi || null"
            class="input"
            autocomplete="off"
            @input="change"
            @focus="onFocus"
            @blur="onBlur"
            @reset="onReset"
            @submit="onSubmit"
            @select="onSelect"
            @keyup="verifyCompleteEvent"
        />

        <span v-if="group" class="group">
            {{ group }}
        </span>

        <span v-if="setError" class="error-icon">
            <i class="fal fa-times"/>
        </span>

        <span v-if="groupicon && type !== 'time'" class="group" :style="{'background': groupIconBackground}">
            <i :class="groupicon" :style="{'color': groupIconColor}"/>
        </span>

        <template v-if="maskIntl">
            <div v-if="typeErrorMessage" class="observation-message">
                {{ typeErrorMessage }}
            </div>
            <div v-if="setError && typeErrorMessage == '' " class="observation-message">
                {{ observation }}
            </div> 
        </template>

        <template v-else>
            <div v-if="observation == '' " class="observation-message">
            {{ typeErrorMessage }}
            </div>

            <div v-if="setError" class="observation-message">
                {{ observation }}
            </div>
        </template>

        <div v-if="loading" class="loading" :class="{'loading-icon-group': loadingIconGroup}">
            <ui-load-indicator :h="20" />
        </div>

        <slot />
    </label>
</template>

<script>
    import { mask } from 'vue-the-mask'
    import { number } from '@/directives'
    import { uiLoadIndicator } from '@/components/ui'
	import { helpersMixin } from '@/mixins'
	const moment = require('moment')
	require('moment/locale/pt-br')

    export default {
        name: 'ui-input',

        directives: {
            mask,
            number,
        },

        components: {
            uiLoadIndicator,
        },

		mixins: [ helpersMixin ],

        props: {
            /**
             * Utilize para aplicar a mascara de número internacional
             * valores aceitos: ['phone', 'mobile', 'phone_resindetial']
             */
            maskIntl: {
                type: String,
                required: false,
				default: ''
            },
			/**
             * Utilizado no contexto de formulário de leads
             */
			 maskIntlErrorDDI55: {
                type: Boolean,
                required: false,
				default: false
            },
            /**
             * Utilize para aplicar as o texto da label
             */
            label: {
                type: String,
                required: false,
				default: ''
            },
            /**
             * Utilize para alterar o tipo do input
             */
            type: {
                type: String,
                required: false,
                default: 'text'
            },
            /**
             * Utilize para referenciar a label a um input
             */
            refer: {
                type: String,
                required: false,
				default: ''
            },
            /**
             * Utilize para colocar um nome no input
             */
            name: {
                type: String,
                required: false,
				default: ''
            },
            /**
             * Utilize para acessar o valor do input
             */
            value: {
				type: null,
                required: false,
				default: ''
            },
            /**
             * Controle de background-color do elemento
             */
            backgroundColor: {
                type: String,
                required: false,
                default:'transparent'
            },
            /**
             * Utilize para aplicar alterar entre os estilos de input
             */
            design: {
                type: [String, Object],
                required: false,
				default: ''
            },
            /**
             * altera a cor do label
             */
            labelColor: {
                type: String,
                default: ''
            },
            /**
             * Utilize para aplicar mask no input
             */
            mask: {
                type: [String, Array, Object],
                required: false,
                default: ''
            },
            /**
             * Utilize para alterar o tamanho do input
             */
            size: {
                type: String,
                required: false,
                default: 'md'
            },
			/**
			 * Utilize para ter um botao ou label  na mesma linha que o input
			 */
			group: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Utilize para adicionar um icone no group
			 */
			groupicon: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Utilize para adicionar uma cor no icone do group
			 */
			groupIconColor: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Utilize para adicionar um background no icone do group
			 */
			groupIconBackground: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Utilize para inverter a posição do 'group'
			 * por padrão fica do lado direito
			 */
			invertgroup: {
				type: Boolean,
				required: false,
				default: false
			},
			/**
			 * Utilize para desabilitar o input
			 */
			disabled: {
				type: Boolean,
				required: false,
				default: false
			},
			/**
			 * Define a propriedade readonly do input
			 */
			readonly: {
				type: Boolean,
				required: false,
				default: false
			},
			/**
			 * Ativa a diretiva Permite apenas que o input receba apenas
			 * números e pontos (para valores flutuantes)
			 */
			number: {
				type: Boolean,
				required: false,
				default: false
			},
			/**
			 * define o input como required em html5 e aplica o operador '*' na label
			 */
			required: {
				type: Boolean,
				required: false,
				default: false
			},
            /**
             * Ativa a diretiva Permite apenas que o input receba apenas
             * números e pontos (para valores flutuantes)
             */
            percent: {
                type: Boolean,
                required: false,
                default: false
            },
            /**
             *Coloca um exemplo no input
             */
            placeholder: {
                type: String,
                required: false,
                default: null
            },
            /**
             * Utilize para remover a mensagem de erro ao receber foco
             */
            clearErrorOnFocus:{
                type: Boolean,
                required: false,
                default: true
            },
            /**
             * Mensagens de validação ou observação.
             */
            observation:{
                type: String,
                default: ''
            },
             /**
             * Utilize para mostrar mensagens de observações no canto superior direito do input
             */

            rightLabel: {
                type: String,
                required: false,
                default: ''
            },

            containerDesign: {
                type: [String, Object],
                required: false,
				default: ''
            },
			/**
			 * Envia um evento quando o usuário parar de digitar no input
			 */
			completeEvent: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Envia um evento quando o usuário sair do foco do input
			 */
			focusEvent: {
				type: String,
				requried: false,
				default: ''
			},
			/**
			 * Utilize para aplicar o estado de loading no input
			 */
			loading: {
				type: Boolean,
				required: false,
				default: false
			},
			/**
			 * Utilize para aplicar o estado de error no input
			 */
			error: {
				type: Boolean,
				required: false,
				default: false
			},
			/*
			*Define se o loading sera aplicado ao lado do icongroup
			*/
			loadingIconGroup: {
				type: Boolean,
				required: false,
				default: false
			},
			/**
			 * Define a quantidade máxima de caractéres a serem aceitas pelo input
			 */
			maxlength: {
				type: [String, Number],
				required: false,
				default: null
			},
            tooltip: {
                type: Object,
                default: () => {}
            },
            /**
			 * Define uma tag de teste para os testes integrados
			 * para o input  do componente
			 */
			 dataUi: {
				type: String,
				required: false,
				default: ''
			},
            width: {
                type: String,
                required: false,
            },
            hasBorderTopBottom: {
                type: String,
                required: false,
                default: ''
            },
        },

        data() {
            return {
                completeInverval: null,
                completeIn: 1000,
                hour: '',
                min: '',
                times: {
                    hours: [],
                    min: []
                },
                timeActved: false,
                openTootip: false,
                typeErrorMessage: '',
                setError: this.error,
                maskDinamic: "+###################",
                countryCodes: 
                {
                    "1": "+# (###) ###-####",
                    "7": "+# (###) ###-##-##",
                    "20": "+## (###) ###-####",
                    "27": "+## ##-###-####",
                    "30": "+## (###) ###-####",
                    "31": "+## ##-###-####",
                    "32": "+## (###) ###-###",
                    "33": "+## (###) ###-###",
                    "34": "+## (###) ###-###",
                    "36": "+## (###) ###-###",
                    "39": "+## (###) ####-###",
                    "40": "+## ##-###-####",
                    "41": "+## ##-###-####",
                    "43": "+## (###) ###-####",
                    "44": "+## ##-####-####",
                    "45": "+## ##-##-##-##",
                    "46": "+## ##-###-####",
                    "47": "+## (###) ##-###",
                    "48": "+## (###) ###-###",
                    "49": "+## (####) ###-####",
                    "51": "+## (###) ###-###",
                    "52": "+## ##-##-####",
                    "53": "+## #-###-####",
                    "54": "+## (###) ###-####",
                    "55": "+## (##) #####-####",
                    "56": "+## #-####-####",
                    "57": "+## (###) ###-####",
                    "58": "+## (###) ###-####",
                    "60": "+## #-####-####",
                    "61": "+## #-####-####",
                    "62": "+## (###) ###-##-###",
                    "63": "+## (###) ###-####",
                    "64": "+## #-###-###",
                    "65": "+## ####-####",
                    "66": "+## ##-###-###",
                    "77": "+## (###) ###-##-##",
                    "81": "+## (###) ###-###",
                    "82": "+## ##-###-####",
                    "84": "+## ##-####-###",
                    "86": "+## (###) ####-###",
                    "90": "+## (###) ###-####",
                    "91": "+## (####) ###-###",
                    "92": "+## (###) ###-####",
                    "93": "+## ##-###-####",
                    "94": "+## ##-###-####",
                    "95": "+## ###-###",
                    "98": "+## (###) ###-####",
                    "211": "+### ##-###-####",
                    "212": "+### ##-####-###",
                    "213": "+### ##-###-####",
                    "216": "+### ##-###-###",
                    "218": "+### ##-###-###",
                    "220": "+### (###) ##-##",
                    "221": "+### ##-###-####",
                    "222": "+### ##-##-####",
                    "223": "+### ##-##-####",
                    "224": "+### ##-###-###",
                    "225": "+### ##-###-###",
                    "226": "+### ##-##-####",
                    "227": "+### ##-##-####",
                    "228": "+### ##-###-###",
                    "229": "+### ##-##-####",
                    "230": "+### ###-####",
                    "231": "+### ##-###-###",
                    "232": "+### ##-######",
                    "233": "+### (###) ###-###",
                    "234": "+### ##-###-##",
                    "235": "+### ##-##-##-##",
                    "236": "+### ##-##-####",
                    "237": "+### ####-####",
                    "238": "+### (###)##-##",
                    "239": "+### ##-#####",
                    "240": "+### ##-###-####",
                    "241": "+### #-##-##-##",
                    "242": "+### ##-#####",
                    "243": "+### (###) ###-###",
                    "244": "+### (###) ###-###",
                    "245": "+### #-######",
                    "246": "+### ###-####",
                    "247": "+### ####",
                    "248": "+### #-###-###",
                    "249": "+### ##-###-####",
                    "250": "+### (###) ###-###",
                    "251": "+### ##-###-####",
                    "252": "+### #-###-###",
                    "253": "+### ##-##-##-##",
                    "254": "+### ###-######",
                    "255": "+### ##-###-####",
                    "256": "+### (###) ###-###",
                    "257": "+### ##-##-####",
                    "258": "+### ##-###-###",
                    "260": "+### ##-###-####",
                    "261": "+### ##-##-#####",
                    "262": "+### #####-####",
                    "263": "+### #-######",
                    "264": "+### ##-###-####",
                    "265": "+### #-###-###",
                    "266": "+### #-###-####",
                    "267": "+### ##-###-###",
                    "268": "+### ##-##-####",
                    "269": "+### ##-#####",
                    "290": "+### ####",
                    "291": "+### #-###-###",
                    "297": "+### ###-####",
                    "298": "+### ###-###",
                    "299": "+### ##-##-##",
                    "350": "+### ###-#####",
                    "351": "+### ##-###-####",
                    "352": "+### (###) ###-###",
                    "353": "+### (###) ###-###",
                    "354": "+### ###-####",
                    "355": "+### (###) ###-###",
                    "356": "+### ####-####",
                    "357": "+### ##-###-###",
                    "358": "+### (###) ###-##-##",
                    "359": "+### (###) ###-###",
                    "370": "+### (###) ##-###",
                    "371": "+### ##-###-###",
                    "372": "+### ####-####",
                    "373": "+### ####-####",
                    "374": "+### ##-###-###",
                    "375": "+### (##) ###-##-##",
                    "376": "+### ###-###",
                    "377": "+### ##-###-###",
                    "378": "+### ####-######",
                    "380": "+### (##) ###-##-##",
                    "381": "+### ##-###-####",
                    "382": "+### ##-###-###",
                    "383": "+### ###-###-###",
                    "385": "+### ##-###-###",
                    "386": "+### ##-###-###",
                    "387": "+### ##-####",
                    "389": "+### ##-###-###",
                    "420": "+### (###) ###-###",
                    "421": "+### (###) ###-###",
                    "423": "+### (###) ###-####",
                    "500": "+### #####",
                    "501": "+### ###-####",
                    "502": "+### #-###-####",
                    "503": "+### ##-##-####",
                    "504": "+### ####-####",
                    "505": "+### ####-####",
                    "506": "+### ####-####",
                    "507": "+### ###-####",
                    "508": "+### ##-####",
                    "509": "+### ##-##-####",
                    "590": "+### (###) ###-###",
                    "591": "+### #-###-####",
                    "592": "+### ###-####",
                    "593": "+### ##-###-####",
                    "594": "+### #####-####",
                    "595": "+### (###) ###-###",
                    "596": "+### (###) ##-##-##",
                    "597": "+### ###-###",
                    "598": "+### #-###-##-##",
                    "670": "+### ###-####",
                    "672": "+### ###-###",
                    "673": "+### ###-####",
                    "674": "+### ###-####",
                    "675": "+### (###) ##-###",
                    "676": "+### #####",
                    "677": "+### #####",
                    "678": "+### #####",
                    "679": "+### ##-#####",
                    "680": "+### ###-####",
                    "681": "+### ##-####",
                    "682": "+### ##-###",
                    "683": "+### ####",
                    "685": "+### ##-####",
                    "686": "+### ##-###",
                    "687": "+### ##-####",
                    "688": "+### #####",
                    "689": "+### ##-##-##",
                    "690": "+### ####",
                    "691": "+### ###-####",
                    "692": "+### ###-####",
                    "850": "+### ###-####-###",
                    "852": "+### ####-####",
                    "853": "+### ####-####",
                    "855": "+### ##-###-###",
                    "856": "+### ##-###-###",
                    "870": "+### ###-###-###",
                    "880": "+### ####-######",
                    "886": "+### ####-####",
                    "960": "+### ###-####",
                    "961": "+### ##-###-###",
                    "962": "+### #-####-####",
                    "963": "+### ##-####-###",
                    "964": "+### (###) ###-####",
                    "965": "+### ####-####",
                    "966": "+### #-###-####",
                    "967": "+### #-###-###",
                    "968": "+### ##-###-###",
                    "970": "+### ##-###-####",
                    "971": "+### #-###-####",
                    "972": "+### ##-###-####",
                    "973": "+### ####-####",
                    "974": "+### ####-####",
                    "975": "+### ##-###-###",
                    "976": "+### ##-##-####",
                    "977": "+### ##-###-###",
                    "992": "+### ##-###-####",
                    "993": "+### #-###-####",
                    "994": "+### ##-###-##-##",
                    "995": "+### (###) ###-###",
                    "996": "+### (###) ###-###",
                    "998": "+### ##-###-####"
                }
            }
        },
        computed: {
            /**
             * Computed property para retornar os valores com as casas decimais formatadas
             * com vírgula
             */
            valueComputed() {
                if (this.percent) return this.value ? String(this.value).replace('.', ',') : null

                return this.value
            },
			localValueIntlNumber() {
                return this.value
            }
        },
        watch: {
            error: {
                immediate: true, // Chama a função de callback imediatamente após o componente ser montado
                handler(newValue) {
                    this.setError = newValue
                },
            },
            observation() {
                if (this.localValueIntlNumber === '+55') {
                    this.setError = false
                    this.$emit('verify', true, this.localValueIntlNumber)
                }
            },
			maskIntlErrorDDI55(){
				if(this.localValueIntlNumber === '+55'){
					this.setError = true
				}
			}
        },
        mounted() {
            for (let index = 0; index <= 23; index++) {
                let value = index < 10 ? `0${index}` : index
                this.times.hours.push(value)
            }
            for (let index = 0; index <= 59; index++) {
                let value = index < 10 ? `0${index}` : index
                this.times.min.push(value)
            }
			this.hour = moment().format('HH')
			this.min = moment().format('mm')
            document.addEventListener('click', this.handleClickOutside) 
        },
 
        beforeDestroy() {
            document.removeEventListener('click', this.handleClickOutside)
        },
        methods: {
			/**
			 * Envia um evento quando o usuário parar de digitar no input
			 */
			verifyCompleteEvent(event) {
				// Verifica se a tecla pressionada é uma das teclas especiais: delete, esc, shift, etc...
				if (!(event.keyCode >= 48 && event.keyCode <= 57) &&
					!(event.keyCode >= 65 && event.keyCode <= 90) &&
					!(event.keyCode >= 96 && event.keyCode <= 109) &&
					![110,111,186,187,188,189,190,191,219,220,221,222].includes(event.keyCode)) {
					this.$emit('keyup', event)
					return
				}
                if(this.maskIntl){
                    if(this.setError == true) return

                    const completeEvent = () => {
						this.$root.$emit(this.completeEvent, event.target.value)
					}
					clearTimeout(this.completeInverval)
					this.completeInverval = setTimeout(completeEvent, this.completeIn)
                } else if (this.completeEvent) {
                    const completeEvent = () => {
						this.$root.$emit(this.completeEvent, event.target.value)
					}
					clearTimeout(this.completeInverval)
					this.completeInverval = setTimeout(completeEvent, this.completeIn)
                }
			},
            /**
             * Trata o evento de quando um valor é digitado no input
             */
            change(event) {
				const valueInput = event.target.value
                if (this.percent) {
                    this.percentegeHandler(event)
                    this.$emit('input', valueInput ? valueInput.replace(',', '.') : null)

                } else if (this.maskIntl) {
                    this.internationalPhoneHandler(event)
					const validation = this.validate(valueInput)

					this.$emit('clearErrorDdi55')
					this.$emit('verify', validation.valid)

					this.setError = valueInput == '+55' ? false : !validation.valid
                    this.$emit('input', valueInput)
                } else {
                    if(this.number) this.numberHandler(event)
                    const validation = this.validate(valueInput)
                    this.$emit('verify', validation.valid, valueInput)
                    this.$emit('input', valueInput)
                }
            },
            onPaste(event){
                if (this.maskIntl){
                    setTimeout(() => {
                    // aplica a mascara internacional (calcula qual deve ser) quando colar o número no input
                        this.maskDinamic = '+###################'
                        this.$emit('input',  event.target.value)
                        this.internationalPhoneHandler(event)  
                    }, 0);
                }
            },
            onFocus(event) {
                /* Comportamento padrão do input ao receber foco */
                if(!this.maskIntl){
                    this.setError = false
                    this.typeErrorMessage = ''
                    if(this.clearErrorOnFocus) this.clearError()
                    this.$emit('focus', event.target.value)
                }
            },
            onBlur(event){
                if (event.target.value == '') {
                    this.setError = this.error
                } else if (!this.maskIntl){ 
                    const validation = this.validate(event.target.value)
                   if( this.typeErrorMessage == '') this.typeErrorMessage = validation.message
                    this.setError = !validation.valid
                }

				if (this.focusEvent && this.focusEvent != '') this.$root.$emit(this.focusEvent)
                this.$emit('blur', event.target.value)
            },
            onReset(event){
                this.$emit('reset', event.target.value)
            },
            onSubmit(event){
                this.$emit('submit', event.target.value)
            },
            onSelect(event){
                this.$emit('select', event.target.value)
            },
            clearError(){
                // this.$refs.field.classList.remove('error')
            },
            internationalPhoneHandler(event){
                const inputValue = event.target.value.replace(/\D/g, '');

                if(inputValue == '55'){
                    this.setError = false
                } 
                if(inputValue.startsWith('55') && inputValue.length > 2 && inputValue.length < 10){
                    this.setError = true
                }

                if(inputValue.length <= 3) this.maskDinamic = '+##################'
                if(inputValue == '') this.typeErrorMessage = ''

                // Regex captura o DDI do números
                const regex = /(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/;
                const match = inputValue.match(regex);
                
                // Usabilidade: aplicar o '+' na frente somente quando for digitado algum número
                if(inputValue.length === 1) this.maskDinamic = '+##################'

                // match: encontrou o DDI; match[1] o próprio DDI
                if (match) {
                    this.typeErrorMessage = ''
                    if(match[1] === '55'){
                        this.maskDinamic = this.maskIntl === 'phone' || this.maskIntl === 'phone_resindetial' ? '+## (##) ####-####' : this.maskIntl === 'mobile' ? '+## (##) #####-####' : '+##################'
                    }else if(this.countryCodes[match[1]] !== undefined){
                        this.maskDinamic = this.countryCodes[match[1]]
                    } else {
                        this.typeErrorMessage = 'DDI não identificado.'
                        this.setError = true
                        this.maskDinamic = '################'
                    }
                } else if(inputValue.length > 3) {
                    this.typeErrorMessage = 'DDI não identificado.'
                    this.setError = true
                }
            
                /**
			    * Problema: Quando a mascara é aplicada o input perde o foco
                * Solução: Separar oque é InputEvent (ação do usuário) e aplicar o foco novamente
			    */
                if(event instanceof InputEvent){
                    this.$nextTick(() => {
                        if (this.$refs.referMaskIntl) {
                            this.$refs.referMaskIntl.focus()
                        }
                    });  
                } 
            
                this.$emit('input', event.target.value)  
            },
			/**
			 * Remove todos os caracteres que não são numéricos
			 */
			numberHandler(event) {
				let regex = /^\d*$/

                if (!regex.test(event.target.value)) {
                    event.target.value = event.target.value.slice( 0, -1 )
                }

				event.target.value = this.isInt(event.target.value) ? event.target.value : null
			},
			/**
			 * Remove todos os caracteres que não são numéricos e aceita um ponto
			 * Usado para números flutuantes
			 */
			percentegeHandler(event) {
				let regex = /^\d*[,]?\d*$/

                if (!regex.test(event.target.value)) {
                    event.target.value = event.target.value.slice(0, -1)
                }

				event.target.value = this.isFloat(event.target.value) ? event.target.value : null
			},
			/**
			 * Checks whether a value is an integer
			 */
			isInt(value) {
				let intRegex = /^-?\d+$/
				if (!intRegex.test(value)) return false

				let intValue = parseInt(value, 10)
				return parseFloat(value) == intValue && !isNaN(intValue)
			},
			/**
			 * Checks whether a value is an float
			 */
			isFloat(value) {
				let result = true
				let floatRegex = /^-?\d+(?:[.,]\d*?)?$/
				if (!floatRegex.test(value)) result = false

				value = parseFloat(value)
				if (isNaN(value)) result = false

				return result
			},
            setHour(time) {
      			this.hour = time
                this.timeActved = true
				this.$emit('input', this.hour + ':' + this.min)
   			},
    		setMin(time) {
      			this.min = time
                this.timeActved = false
				this.$emit('input', this.hour + ':' + this.min)
    		},
            maxTime(type) {
                if(type === 'hour') {
                    this.hour = this.hour > 23 ? 23 : this.hour
                    this.setHour(this.hour)
                } else {
                    this.min = this.min > 59 ? 59 : this.min
                    this.setMin(this.min)
                }

            },
            /**
             * Verifica se a string informada é um e-mail válido
             *
             * @param {String} text
             */
            isEmail(text) {
                // Expressão regular para verificar se o texto é um endereço de e-mail
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                // Testa se o texto corresponde ao padrão do endereço de e-mail
                return emailPattern.test(text);
            },
            /**
             * Verifica se a string informada é um número de celular válido
             *
             * @param {String} text 
             */
             isCelPhoneNumberIntl(text) {
                // Divide pelo caractere '#' para contar quantos dígitos a mascara possui
                let countMask = this.maskDinamic.split('#');
                // Conta quantos dígitos o número tem
                let digitMatches = text.match(/\d/g);
                let digits = digitMatches ? digitMatches.length : 0;
                let textSanit = text.replace(/\D/g, '');
                // Verifica se encontra o DDI 
                const regex = /(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{1,14}$/;
                const match = textSanit.match(regex);

                // Verifica se a quantidade de dígitos e o código do país são os mesmo (mascara completa)
                if (countMask.length - 1 === digits && match && this.countryCodes[match[1]] !== undefined) {
                    return true;
                }

				if(textSanit == '55' || textSanit == ''){
					this.typeErrorMessage = ''
				}else{
					this.typeErrorMessage = 'O número está inválido'
				}

                return false;
            },
            isCelNumber(text) {
                // Expressão regular para verificar se o texto é um número de celular formatado
                let cellPhonePattern = /^\(\d{2}\) \d{5}-\d{4}$/;
                // Validação caso seja mascara internacional
                if(this.maskIntl){
                    cellPhonePattern = /^\+55 \(\d{2}\) \d{5}-\d{4}$/
                    if(!cellPhonePattern.test(text)){
                        return this.isCelPhoneNumberIntl(text)
                    }
                }
                // Testa se o texto corresponde ao padrão de número de celular formatado
                return cellPhonePattern.test(text) 
            },
            /**
             * Verifica se a string informada é um número de telefone válido
             *
             * @param {String} text 
             */
            isPhoneNumber(text) {
                // Expressão regular para verificar se o texto é um número de telefone formatado
                let phonePattern = /^\(\d{2}\) \d{4}-\d{4}$/;
                // Validação caso seja mascara internacional
                if(this.maskIntl){
                    phonePattern = /^\+55 \(\d{2}\) \d{4}-\d{4}$/;
                    if(!phonePattern.test(text)){
                        return this.isCelPhoneNumberIntl(text)
                    }
                }
                // Testa se o texto corresponde ao padrão de número de telefone formatado
                return phonePattern.test(text);
            },
            /**
             * Valida o dado do input de acordo com o tipo definido
             *
             * @param {String} value 
             */
            validate(value) {
                let message = ''
                let valid = true
				
                if (this.type == 'email' && !this.isEmail(value)) {
                    message = 'O e-mail está inválido'
                    valid = false
                }

				// A função containsWord ajuda a validar tanto campos de input normal quanto os inputs dinâmicos do formulário de leads
                if(this.containsWord(this.type, 'tel') && this.containsWord(this.label, 'celular') && !this.isCelNumber(value) || 
                this.containsWord(this.type, 'tel') && this.containsWord(this.label, 'telefone') && !this.isPhoneNumber(value) || 
                this.type == 'text' && this.containsWord(this.label, 'telefone') && !this.isPhoneNumber(value) || 
                this.type == 'text' && this.containsWord(this.label, 'celular') && !this.isCelNumber(value)) {
                    message = 'O número está inválido'
                    valid = false
                }

				if(this.label && this.containsWord(this.label, 'cpf') && !this.$mx_validateCPF(this.value)){
					message = 'Digite um CPF válido'
					valid = false
				}
				if(this.label && this.containsWord(this.label, 'cnpj') && !this.$mx_validateCNPJ(this.value)){
					message = 'Digite um CNPJ válido'
					valid = false
				}
				
                return { message, valid }
            },
			containsWord(textToSearch, searchTerm){
				if(!textToSearch ||!searchTerm) return false
				
				const regex = new RegExp(searchTerm, 'i');
				return regex.test(textToSearch);
			}
		}
	}
</script>
<style lang="stylus" scoped>
    @import './styles.styl';
</style>
